<template>
  <div class="wrapper">
    <filters />
    <inner-list
      :loading="loading"
      :results="results"
      :pagination="pagination"
    />
  </div>
</template>
<script>
import InnerList from './InnerList'
import Filters from './Filters'
import { ReservedSlot } from '@/api'
import PaginatedList from '@/components/layout/PaginatedList'

export default {
  extends: PaginatedList,
  components: {
    InnerList,
    Filters
  },
  data() {
    return {
      service: ReservedSlot
    }
  },
  computed: {
    params() {
      return {
        ...this.$route.query,
        course: this.$route.params.courseId
      }
    }
  }
}
</script>
